// src/components/dashboard/admin/AdminHeader.jsx
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FaUser, 
  FaSignOutAlt, 
  FaCog,
  FaChevronDown
} from 'react-icons/fa';
import { useAuth } from '../../../hooks/useAuth';

const AdminHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <header 
      className="shadow-lg border-b border-gray-200"
      style={{
        background: 'linear-gradient(to right, #ca3925 10%, #dc2626 300px, #ffffff 500px)'
      }}
    >
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Banner Logo */}
          <Link to="/admin/dashboard" className="flex items-center pl-4">
            <img
              src="/winnepocketbanner.webp"
              alt="Winnepocket Landscaping - Admin"
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* Right side */}
          <div className="flex items-center space-x-4 pr-4">
            {/* User Menu */}
            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 hover:bg-opacity-20 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 backdrop-blur-sm"
              >
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                  <FaUser className="w-4 h-4 text-red-600" />
                </div>
                <div className="hidden md:block text-left">
                  <p className="text-sm font-medium text-gray-700">
                    {user?.displayName || 'Admin'}
                  </p>
                  <p className="text-xs text-gray-500">{user?.email}</p>
                  <p className="text-xs text-red-600 font-medium">Administrator</p>
                </div>
                <FaChevronDown className="w-4 h-4 text-gray-400" />
              </button>

              {/* User Dropdown */}
              {showUserMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
                  <div className="py-1">
                    <Link
                      to="/admin/settings"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => setShowUserMenu(false)}
                    >
                      <FaCog className="w-4 h-4 mr-3" />
                      Admin Settings
                    </Link>
                    <hr className="my-1" />
                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      <FaSignOutAlt className="w-4 h-4 mr-3" />
                      Sign out
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;